var blockquote_default = {
  "fontElementMap": "MYTb-",
  "quote": "_9iu5l"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
